import type SubjectTypeDefinitionFormData from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import type { SpeakerRoleDraft } from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import * as React from 'react';
import { Grid, GridItem } from '@verclam/grid-system';
import { Button, InputText } from '@verclam/ui-kit';

type Props = {
	readonly formData: SubjectTypeDefinitionFormData;
	readonly onChange: (
		update: (formData: SubjectTypeDefinitionFormData) => SubjectTypeDefinitionFormData,
	) => void;
	readonly index: number;
	readonly role: SpeakerRoleDraft;
	readonly isReadOnly: boolean;
};

/** One speaker role: its label, editable, and the button removing it. */
const SpeakerRoleRow: React.FC<Props> = ({ formData, onChange, index, role, isReadOnly }) => {
	const serverMessage = formData.getSpeakerRoleServerMessage(index);

	const handleLabelChange = React.useCallback(
		(value: string) => {
			onChange((current) => current.renameSpeakerRole(index, value));
		},
		[onChange, index],
	);

	const handleRemoveClick = React.useCallback(() => {
		onChange((current) => current.removeSpeakerRole(index));
	}, [onChange, index]);

	return (
		<Grid columns={12} columnGap={1} alignItems="start">
			<GridItem columnSize={{ xs: 12, xl: 9 }}>
				<InputText
					name={`speakerRole${index}`}
					label={`Rôle de locuteur ${index + 1}`}
					isLabelHidden
					value={role.label}
					disabled={isReadOnly}
					onChange={handleLabelChange}
					errorMessage={serverMessage ?? undefined}
					isFormFieldValid={serverMessage === null}
				/>
			</GridItem>
			<GridItem columnSize={{ xs: 12, xl: 3 }}>
				<Button
					type="button"
					size="sm"
					severity="secondary"
					label="Retirer"
					disabled={isReadOnly}
					onClick={handleRemoveClick}
				/>
			</GridItem>
		</Grid>
	);
};

export default SpeakerRoleRow;
